//应用场景




import { Tabs } from 'antd';
import { RootObject,TabsList } from '../../type';
import Content from './content/Content';
import './style.less';

const { TabPane } = Tabs;
const ApplicationScenarios = (props: RootObject["applicationScenarios"]) => {
  return (
    <div className="applicationScenarios">
      <div className="applicationScenarios_title">
        {props.title ?? ""}
      </div>

      <div className="applicationScenarios_tabs" >
        <Tabs
          className="applicationScenarios_tab"
          defaultActiveKey="1"
          tabPosition="left" >
            {
              props.tabsList.map((value:TabsList,index:number)=>{
                return (
                  <TabPane tab={value.title} key={index + 1}
                  >
                  <Content {...value}/>
                </TabPane>
                )
              })
            }
       
        </Tabs>
      </div>
    </div>
  )
}

export default ApplicationScenarios;